import { triggerCustomEvent } from "../utils/eventHelpers.ts";

export interface ConfigurationProduct {
	matnr: string;
	productGroupId: string;
}

export interface CreateConfigurationRequest {
	configBundleId: string;
	configuration: ConfigurationProduct[];
	isNewConfigurePage: boolean;
}

export interface AddToCartRequest {
	dto: AddToCartItem[];
	renewalPeriod?: string;
}

export interface AddToCartItem {
	productId: string;
	quantity: number;
	renewalPeriod?: string;
	isPartOfSubscription: boolean;
	configBundle: {
		configurationId: string;
	};
}

export interface AddToCartResponse {
	messages: Array<{
		level: string;
		message: string;
		key?: string;
	}>;
	summary: {
		totalNet: number;
		totalGross: number;
		quantity: number;
	};
	flags: {
		showNetPrices: boolean;
	};
	store: {
		language: string;
	};
}

export const createConfigurationId = async (
	configBundleId: string,
	products: Array<{ matnr: string; productGroupId: string }>
): Promise<string> => {
	const request: CreateConfigurationRequest = {
		configBundleId,
		configuration: products,
		isNewConfigurePage: true,
	};

	const response = await fetch(`/configure/configurations/create`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	return await response.text();
};

export const addConfigurationToCart = async (
	bundleId: string,
	configurationId: string,
	renewalPeriod?: string
): Promise<AddToCartResponse> => {
	const request: AddToCartRequest = {
		dto: [
			{
				productId: bundleId,
				quantity: 1,
				renewalPeriod,
				isPartOfSubscription: !!renewalPeriod,
				configBundle: {
					configurationId,
				},
			},
		],
		renewalPeriod,
	};

	const response = await fetch(`/cart/api/add`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	return await response.json();
};

export const updateSmallCart = (cartData: AddToCartResponse): void => {
	if (!cartData.summary) {
		return;
	}

	const prices = {
		isGross: !cartData.flags.showNetPrices,
		totalNet: cartData.summary.totalNet,
		totalGross: cartData.summary.totalGross,
		quantity: cartData.summary.quantity,
	};

	triggerCustomEvent("cartUpdated", { detail: prices });
};

export const addProductToCart = async (
	productId: string,
	quantity: number = 1
): Promise<AddToCartResponse> => {
	const response = await fetch("/cart/api/add", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			dto: [
				{
					productId,
					quantity,
					isPartOfSubscription: false,
				},
			],
		}),
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	return await response.json();
};